<template>
  <b-row class="m-0">
    <div :class="['backgroud-primary-absolute', { 'is-whitelabel': is_whitelabel }]"></div>
    <b-row>
      <b-col class="col-12 col-lg-6 py-1">
        <auto-search @open_side_summary="openSummaryProfile"></auto-search>
      </b-col>
     
      <card-marketing class="col-12 col-lg-6 py-1"
        :badgeBalance="false"
        :infoBalance="getBalance"
        :textBadge="$t('creator.convocateInfluencers')"
        :textInfo="$t('creator.convocateInfluencersText')"
        :textButton="$t('dashboard.create_casting_call')"
        :textLink="$t('creator.convocateInfluencersTextSmall')"
        :link="$t('creator.convocateInfluencersLink')"
        :reference_link="'https://soporte.brandme.la/base-de-conocimientos/como-crear-una-campana-externa-en-brandme-1/'"
        :img="getUrlCategory('cover_crowdmarketing')"
        :reference="avaible_plan ? { name: 'steps_casting_call', params: {step: 'organization-search'}} : 'open_modal_membership'"
        :colorCard="'card-white'"
      >
      </card-marketing>
    </b-row>

    <b-row class="w-100 m-0">
      <b-col class="col-12 mt-2 w-100 p-0">
        <brand-overview :avaible_plan="avaible_plan" :is_whitelabel="is_whitelabel"></brand-overview>
      </b-col>
    </b-row>
  </b-row>

</template>
  
<script>
import { 
  BRow, 
  BCol
} from "bootstrap-vue";
import { getUserData } from '@/libs/utils/user'
import { getUrlCategory } from '@/libs/utils/urls';

export default {
  name: "DashboardBrand",
  components: {
    BRow,
    BCol,
    AutoSearch: () => import('@/views/search/search.vue'),
    brandOverview: () => import('./brandOverview.vue'),
    cardMarketing: () => import('@/views/components/proposals/cardMarketing.vue'),
  },
  data() {
    return {
      getUserData,
      getUrlCategory,
    };
  },

  computed: {
    avaible_plan() {
      return getUserData().current_plan.create_casting_call
    },
    getBalance() {
      return getUserData().balance
    },
    is_whitelabel() {
      return false;
      // return getUserData()?.main_group?.name === 'whitelabel';
    },
  },
  methods: {
    openSummaryProfile(item) {
      this.$emit('open_side_summary', item);
    },
  },
};
</script>
<style>
.banner-leads .card-body {
  display: flex;
  justify-content: flex-start;
}
.icon-leads {
  background-color: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  padding: 5px;
  margin-right: 10px;
  border-radius: 10px;
  height: 40px;
  width: 40px;
  min-width: 40px;
} 
.hoverCard:hover {
  transform: scale(1.05);
  transition: all 500ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.header-card-creator {
  height: 188px;
}
.text-black {
  color: #6e6b7b;
}
.nav-brands-dashboard .nav-tabs .nav-link {
  color: #cdcdcd;
  padding: 0;
  margin: 1em 1em 0 0;
  font-weight: bolder;
}
.underline-nav-item {
  border-bottom: 3px solid white !important;
}
</style>
<style lang="scss" scoped> 
.card-convocate {


  .images-inner-first {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: -4em;
  }
}
.backgroud-primary-absolute {
  background: rgb(125,42,231);
  background: -moz-linear-gradient(173deg, rgba(125,42,231,1) 14%, rgba(0,196,204,1) 97%);
  background: -webkit-linear-gradient(173deg, rgba(125,42,231,1) 14%, rgba(0,196,204,1) 97%);
  background: var(--header-bg);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#7d2ae7",endColorstr="#00c4cc",GradientType=1);
  position: absolute;
  top: 11.5em;
  left: 0;
  height: 700px;
  width: 100%;

  &.is-whitelabel {
    background: var(--header-bg);
  }
}
@media(max-width: 1199px) {
  .backgroud-primary-absolute {
    top: 5em;
    left: 0;
    height: 800px
  }
} 
</style>